module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.16437/images/content-empty-icon.svg"